(function () {

	angular
		.module('ngmvac')
		.filter('orderByCategoryFilter', OrderByCategoryFilter);

	function OrderByCategoryFilter() {

        return function ( items, order ){
            
            var DIFFERENT = 100;
            
            function getCategory( categoryCode ){
                
                patterns = [
					/((\d)EST)/,
					/(\d)LUX/,
					/((\d)S)/,
					/H(\d)_\d/,
					/SUP/
				];

                for ( var i = 0; i < patterns.length; i++ ) {
					var matches = patterns[i].exec(categoryCode);
					if ( matches === null ) continue;
					if ( i === 4 ) return 15;
					var categoryValue = parseInt( matches[1] );
					return ( i + 1 ) + ( 4 * categoryValue - 1 );
				}

                return DIFFERENT;
            }

            var list = items.sort(function ( firstItem, secondItem ) {
				var firstItemValue     = getCategory( firstItem.categoryCode );
				var secondItemValue   = getCategory( secondItem.categoryCode );
				if ( firstItemValue === DIFFERENT ) return 1;
				if ( secondItemValue === DIFFERENT ) return -1;
				if (order === 'LOWER')
				return firstItemValue - secondItemValue;
					else 
				return secondItemValue - firstItemValue;
			});

            return list;
        }
    }
})();